import * as React from 'react'

import { Box, Grid, Typography, IconButton, Tooltip } from '@material-ui/core'

import SettingsIcon from '@material-ui/icons/Settings'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import SearchDialog from '../../../features/dashboard/DashboardComponents/SearchDialog/SearchDialog'

import { addProfileLogEvent } from '../../../features/dashboard/widgets/MyProfile/myProfileSlice'
import { toggleShowSensitiveInfo } from '../../../features/settings/settingsSlice'
import { handleLogoutClick } from '../../../features/settings/pages/Main'
import ManageWidgets from '../../../features/dashboard/DashboardComponents/ManageWidgets/ManageWidgets'
import { getShowVisitorLabel } from '../../../../utils/utils'
import { trackEvent } from '../../../helpers/analytics'
import {
  MyAlertsAndNotifications,
  AlertDialog,
} from '../../../features/dashboard/widgets/MyAlerts/Components/MyAlertsAndNotifications'

export { MyAlertsAndNotifications, AlertDialog }

export const VisitorModeLabel = ({ classes, isMobile }) => {
  if (
    localStorage.getItem('user') !== '"visitor"' &&
    !localStorage.getItem('loginRedirect')
  )
    return null
  return (
    <Box
      className={
        isMobile ? classes.visitorModeLabelMobile : classes.visitorModeLabel
      }
    >
      <Typography variant="p">Visitor Mode</Typography>
    </Box>
  )
}

export const LogOutButton = ({ classes, dispatch, userProfile, isMobile }) => {
  const showVisitorModeLabel = getShowVisitorLabel()
  const logoutButtonAction = {
    title: showVisitorModeLabel ? 'Log in' : 'Log out',
    ariaLabel: showVisitorModeLabel ? 'Log in' : 'Log out',
  }
  const handleLogoutClickHandler = () => {
    trackEvent(dispatch, {
      eventName: 'uxp_logout_click',
      module: 'UXP Shell',
      object: 'LogoutButton',
      action: 'Click',
      actionContext: 'Logout',
      actionContextValue: 'UserLoggedOut',
    })
    if (showVisitorModeLabel) {
      if (window.location.href?.includes('/maps')) {
        localStorage.setItem('loginRedirect', '/maps')
      }
      window.location.href = process.env.REACT_APP_LOGIN_LINK
    } else {
      handleLogoutClick(dispatch, userProfile)
    }
  }
  return (
    <>
      {isMobile === false && (
        <Grid item>
          <Tooltip
            title={
              <Typography variant="subtitle2">
                {logoutButtonAction.title}
              </Typography>
            }
            placement="top"
            arrow
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label={logoutButtonAction.ariaLabel}
              onClick={handleLogoutClickHandler}
            >
              <ExitToAppIcon className={classes.appBarIcon} />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
    </>
  )
}

// TODO Add back sensitive info toggle (Should do with login updates)
export default function DashboardLocalButtons(
  classes,
  history,
  dispatch,
  showSensitiveInfo,
  isMobile,
  dialogOpen,
  searchOpen,
  activeAlerts,
  userProfile,
  activeNotificationList,
) {
  // const his = useHistory()
  const handlePrivacyClick = () => {
    if (process.env.REACT_APP_FIREBASE_ON === 'true') {
      dispatch(
        addProfileLogEvent({
          module: 'TopAppBar',
          object: 'TopAppBarButton',
          objectId: 'TopAppBarItem',
          action: 'Click',
          actionContext: 'VisibilityIconClick',
          actionContextValue: showSensitiveInfo
            ? 'sensitiveInfoOff'
            : 'sensitiveInfoOn',
          rcpid: localStorage.getItem('rutgersEduRCPID'),
          timestamp: Date.now(),
        }),
      )
    }
    trackEvent(dispatch, {
      eventName: 'uxp_visibility_toggle',
      module: 'UXP Shell',
      object: 'VisibilityToggle',
      action: 'Click',
      actionContext: 'privacy',
      actionContextValue: showSensitiveInfo
        ? 'sensitiveInfoOff'
        : 'sensitiveInfoOn',
    })
    dispatch(toggleShowSensitiveInfo())
  }

  const isGuest = localStorage.getItem('user') === '"visitor"'

  return (
    <Grid item md={4}>
      <Grid container justifyContent="flex-end" alignItems="center">
        {!isMobile ? (
          <Grid item style={{ marginRight: 4 }}>
            <VisitorModeLabel classes={classes} />
          </Grid>
        ) : null}
        {!isGuest && (
          <Grid item>
            <ManageWidgets />
          </Grid>
        )}

        {!isGuest && (
          <Grid item>
            <Tooltip
              title={
                <Typography variant="subtitle2">
                  Show/Hide Privacy Items
                </Typography>
              }
              placement="top"
              arrow
            >
              <IconButton
                edge="start"
                className={classes.rightIconSpacer}
                color="inherit"
                aria-label="Show/Hide Privacy Items"
                onClick={handlePrivacyClick}
              >
                {showSensitiveInfo ? (
                  <Visibility className={classes.appBarIcon} />
                ) : (
                  <VisibilityOff className={classes.appBarIcon} />
                )}
              </IconButton>
            </Tooltip>
          </Grid>
        )}
        <Grid item>
          <SearchDialog open={searchOpen} isMobile={isMobile} />
        </Grid>

        <MyAlertsAndNotifications
          dispatch={dispatch}
          isMobile={isMobile}
          isGuest={isGuest}
          classes={classes}
          activeAlerts={activeAlerts}
          activeNotificationList={activeNotificationList?.length}
          dialogOpen={dialogOpen}
        />
        {isMobile && (
          <Grid item>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Settings Menu"
              onClick={() => {
                trackEvent(dispatch, {
                  eventName: 'uxp_settings_view',
                  module: 'TopAppBar',
                  object: 'SettingsIcon',
                  action: 'view',
                  actionContext: 'Settings',
                  actionContextValue: 'SettingsMenuOpened',
                })
                history.push('/settings')
              }}
            >
              <SettingsIcon className={classes.appBarIcon} />
            </IconButton>
          </Grid>
        )}
        <LogOutButton
          isMobile={isMobile}
          dispatch={dispatch}
          userProfile={userProfile}
          classes={classes}
          history={history}
        />
      </Grid>
    </Grid>
  )
}
